module.exports = __webpack_public_path__ + "img/35c0650.prt.201f4ead.jpg";